import { z } from 'zod';
import { CONTENT_LOCALES } from '../enums/locale';

export const Translation = z.object({
  locale: z.enum(CONTENT_LOCALES, {
    message: 'VALIDATION__InvalidLocale',
  }),
  name: z
    .string()
    .min(3, 'VALIDATION__Min3CharLimit')
    .max(255, 'VALIDATION__Max255CharLimit'),
  description: z.string().optional(),
  comment: z.string().min(3, 'VALIDATION__Min3CharLimit').optional(),
});
